module.exports = __webpack_public_path__ + "media/images/benefit-date-check-66afae2a82c805da86d135ac517389e2.svg";